import firebase from "firebase/app";
import {mapGetters} from "vuex";
import logging from '@/assets/js/functions/_core/logging';
import toast from "@/assets/js/functions/_core/toast";

export default {
  mixins: [logging, toast],

  computed: {
    ...mapGetters({isLogin: 'auth/isLogin'}),
  },

  methods: {
    async login(email, password) {
      await firebase.auth().signInWithEmailAndPassword(email, password).catch(error => {
        this.logger(error, "ログインに失敗しました");
        throw error;
      });
    },

    async logout() {
      firebase.auth().signOut();
      if (this.$router.currentRoute.name !== 'Top') this.$router.push({name: 'Top'});
    },

    async resendVerifyingEmail() {
      await firebase.auth().currentUser.sendEmailVerification().then(() => {
        this.showSuccessMessage('認証メールを再送信しました');
      }).catch(error => {
        this.logger(error, "認証メールの再送信に失敗しました。");
        throw error;
      });
    },

    async passwordReset(email) {
      await firebase.auth().sendPasswordResetEmail(email).catch(error => {
        this.logger(error, "パスワード再設定メールの送信に失敗しました");
        throw error;
      });
    },
  }
}
